// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cx7J","type":"styles_type__1KPFp","choices":"styles_choices__xbdhn"};